import React from 'react';
import Modal from 'react-modal';

// Optional: set the app element for accessibility
Modal.setAppElement('#root');

const ConfirmModal = ({ isOpen, message, onConfirm, onCancel,showCancelButton = true }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      contentLabel="Confirmation Dialog"
      // ใช้ overlayClassName สำหรับสไตล์ของพื้นหลังสีดำโปร่งแสง
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      // ใช้ className สำหรับสไตล์ของตัวกล่อง Modal
      className="bg-white rounded-lg p-6 shadow-xl w-full max-w-sm mx-4"
    >
      {/* ข้อความใน Modal */}
      <p className="text-lg text-gray-800 mb-4">{message}</p>
      
      {/*โซนของปุ่ม */}
      <div className="flex justify-end gap-x-2">
        {/* ปุ่มยกเลิก */}
        {showCancelButton && (
          <button 
            onClick={onCancel} 
            className="px-4 py-2 rounded-md bg-red-500 text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-75"
          >
            ยกเลิก
          </button>
        )}
        
        {/* ปุ่มตกลง */}
        <button 
          onClick={onConfirm} 
          className="px-4 py-2 rounded-md bg-green-500 text-white  hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-75"
        >
          ตกลง
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmModal;